import { render, staticRenderFns } from "./ReadRemindList.vue?vue&type=template&id=521d4649&scoped=true&"
import script from "./ReadRemindList.vue?vue&type=script&lang=js&"
export * from "./ReadRemindList.vue?vue&type=script&lang=js&"
import style0 from "./ReadRemindList.vue?vue&type=style&index=0&id=521d4649&scoped=true&lang=css&"
import style1 from "./ReadRemindList.vue?vue&type=style&index=1&id=521d4649&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521d4649",
  null
  
)

export default component.exports